import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e59c4012"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "screen" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "省", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "市", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "区", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "镇", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "业务编码", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "状态", -1))
const _hoisted_8 = { class: "searchBox" }
const _hoisted_9 = { style: {"margin-top":"20px","background":"#fff","padding":"12px"} }
const _hoisted_10 = { style: {"margin-bottom":"16px","display":"flex","justify-content":"space-between","align-items":"center"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "moduleTitle" }, "地区列表", -1))
const _hoisted_12 = { class: "tableBox" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "buttonBox" }
const _hoisted_16 = { style: {"display":"flex","justify-content":"space-between","margin-top":"20px"} }
const _hoisted_17 = { style: {"color":"red"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_Col = _resolveComponent("Col")!
  const _component_Option = _resolveComponent("Option")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Row = _resolveComponent("Row")!
  const _component_Switch = _resolveComponent("Switch")!
  const _component_Table = _resolveComponent("Table")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Row, null, {
        default: _withCtx(() => [
          _createVNode(_component_Col, { span: 5 }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createVNode(_component_Input, {
                value: _ctx.province,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.province) = $event)),
                placeholder: "请输入"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_Col, { span: 1 }),
          _createVNode(_component_Col, { span: 5 }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createVNode(_component_Input, {
                value: _ctx.city,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.city) = $event)),
                placeholder: "请输入"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_Col, { span: 1 }),
          _createVNode(_component_Col, { span: 5 }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createVNode(_component_Input, {
                value: _ctx.area,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.area) = $event)),
                placeholder: "请输入"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_Col, { span: 1 }),
          _createVNode(_component_Col, { span: 5 }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createVNode(_component_Input, {
                value: _ctx.town,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.town) = $event)),
                placeholder: "请输入"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_Col, { span: 1 }),
          _createVNode(_component_Col, { span: 5 }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createVNode(_component_Input, {
                value: _ctx.code,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.code) = $event)),
                placeholder: "请输入"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_Col, { span: 1 }),
          _createVNode(_component_Col, { span: 5 }, {
            default: _withCtx(() => [
              _hoisted_7,
              _createVNode(_component_Select, {
                value: _ctx.status,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.status) = $event)),
                style: {"width":"100%"},
                placeholder: "请选择"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Option, { value: "" }, {
                    default: _withCtx(() => [
                      _createTextVNode("全部")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Option, { value: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode("启用")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Option, { value: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode("禁用")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_Col, { span: 1 }),
          _createVNode(_component_Col, { span: 5 }),
          _createVNode(_component_Col, { span: 1 }),
          _createVNode(_component_Col, {
            span: 5,
            class: "searchBoxfather"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_Button, {
                  type: "primary",
                  onClick: _ctx.search
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("搜索")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_Button, {
                  style: {"margin-left":"10px","border-color":"#008bcf","color":"#008bcf"},
                  onClick: _ctx.reset
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("重置")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", null, [
          (_ctx.$store.state.authc.authc.ButtonBasic_pg_basiData_areaList_add)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                type: "primary",
                style: {"margin":"0 16px"},
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.terminalDetails()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 新增地区 ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_Table, {
          rowKey: "code",
          "row-selection": {
            selectedRowKeys: _ctx.selectedRowKeys,
            onChange: _ctx.onSelectChange,
          },
          columns: _ctx.columns,
          "data-source": _ctx.data,
          pagination: false,
          scroll: _ctx.scroll,
          loading: _ctx.loading,
          size: "small"
        }, {
          code: _withCtx(({ record }) => [
            (_ctx.$store.state.authc.authc.ButtonBasic_pg_basiData_areaList_edit)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "javascript:",
                  onClick: ($event: any) => (_ctx.terminalDetails(record.code))
                }, _toDisplayString(record.code), 9, _hoisted_13))
              : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(record.code), 1))
          ]),
          handle: _withCtx(({ record }) => [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_Switch, {
                onChange: ($event: any) => (_ctx.disableAreaByCode(record.code, record.status)),
                checked: _ctx.computeStatus(record.status),
                disabled: !_ctx.$store.state.authc.authc.ButtonBasic_pg_basiData_areaList_state
              }, null, 8, ["onChange", "checked", "disabled"])
            ])
          ]),
          _: 1
        }, 8, ["row-selection", "columns", "data-source", "scroll", "loading"])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", null, [
          _createTextVNode(" 共 " + _toDisplayString(_ctx.total) + " 条数据 / 已选择 ", 1),
          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.selectedRowKeys.length), 1),
          _createTextVNode(" 条 ")
        ]),
        _createVNode(_component_Pagination, {
          "show-size-changer": "",
          "show-quick-jumper": "",
          current: _ctx.pageCurrent,
          "onUpdate:current": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.pageCurrent) = $event)),
          pageSize: _ctx.pageSize,
          "onUpdate:pageSize": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.pageSize) = $event)),
          total: _ctx.total,
          onShowSizeChange: _ctx.onShowSizeChange,
          "page-size-options": ['10', '20', '50', '100']
        }, null, 8, ["current", "pageSize", "total", "onShowSizeChange"])
      ])
    ])
  ]))
}